import React, { useRef } from 'react';
import styled from 'styled-components';

const TabContainer = styled.div`
  display:flex;border-bottom:2px solid ${p => p.theme.colors.border};
  overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;
  &::-webkit-scrollbar{display:none;}
`;
const Tab = styled.button`
  padding:10px 16px;border:none;background:transparent;cursor:pointer;
  white-space:nowrap;
  font-weight:${p => p.$active ? p.theme.typography.weights.semibold : p.theme.typography.weights.regular};
  color:${p => p.$active ? (p.$accent || p.theme.colors.primary) : p.theme.colors.text.secondary};
  border-bottom:3px solid ${p => p.$active ? (p.$accent || p.theme.colors.primary) : 'transparent'};
  transition:all 0.2s;min-height:44px;font-size:${p => p.theme.typography.sizes.sm};
  &:hover{color:${p => p.$accent || p.theme.colors.primary};}
`;
const Badge = styled.span`
  font-size:${p => p.theme.typography.sizes.xs};
  color:${p => p.theme.colors.text.muted};
  font-weight:${p => p.theme.typography.weights.regular};
  margin-left:2px;
`;

export default function ResultTabs({ tabs, activeTab, onTabChange, accentColor }) {
  const tabRefs = useRef([]);

  const handleKeyDown = (e) => {
    const idx = tabs.findIndex(t => t.key === activeTab);
    let next = idx;
    if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = tabs.length - 1;
    else return;
    e.preventDefault();
    onTabChange(tabs[next].key);
    tabRefs.current[next]?.focus();
  };

  return (
    <TabContainer role="tablist" onKeyDown={handleKeyDown}>
      {tabs.map((t, i) => (
        <Tab key={t.key} $active={activeTab === t.key} $accent={accentColor}
          onClick={() => onTabChange(t.key)}
          role="tab" aria-selected={activeTab === t.key}
          tabIndex={activeTab === t.key ? 0 : -1}
          ref={el => tabRefs.current[i] = el}>
          {t.label}
          {t.badge != null && <Badge> · {t.badge}</Badge>}
        </Tab>
      ))}
    </TabContainer>
  );
}
